// Get query for getting site data

const getQuery = async ({ queryKey }) => {
  const data = await fetch(
    `${process.env.SNAPHUNT_API_URL}${queryKey[0]}`,
  ).then(res => res.json());

  return data;
};

export default getQuery;
